export const getChapterSectionElementRef = (
  chapterId: number,
  sectionId: number,
) => `c${chapterId}-s${sectionId}`;
